<template>
    <div class="chart-block" style="min-height:297px">
        <h3>   <a :href="url" target="_blank"> {{chartName}}</a></h3>
        <div class="share-block">
            <div class="share-user">
                <div class="icon" ><img src="../../assets/images/wu.png"></div>
                <div class="content">
                     <div class="sign">sam   <span>刚刚</span></div>
                    <div class="sc">分享了方案 《2019纯电动销量分析》</div>
                </div>
            </div>
             <div class="share-user">
                 <div class="icon"><img src="../../assets/images/xiaodu.png"></div>
                <div class="content">
                     <div class="sign">sam   <span>5分钟前</span></div>
                    <div class="sc">分享了方案 《新4化》</div>
                </div>
            </div>
             <div class="share-user">
                <div class="icon"><img src="../../assets/images/chenli.png"></div>
                <div class="content">
                     <div class="sign">sam   <span>1小时前</span></div>
                    <div class="sc">分享了方案 《这个杀手有点冷》.</div>
                </div>
            </div>
            
        </div>
        
    </div>
</template>
<script>
    import echarts from 'echarts'
    export default {
        props: {
            chartName: {
                type: String,
                default: '最新方案分享'
            }
        },
        data() {
            return {
                url:"",
                chartOption: {}
            }
        },
        mounted() {
        },
        methods: {},
        watch: {},
        created() {}
    }
</script>
 <<style scoped>
 .share-block{
     padding:10px 15px;
 }
    .share-user {
        display: flex;
        width: 100%;
        height: 65px;
        border-bottom:1px solid #ccc;
     
    }
    .share-user .icon {
        width: 50px;
        height: 50px;
        background-size: 100% 100%;
        width: 40px; height: 40px;  border-radius: 20%;   overflow: hidden;
        margin: auto auto;
      
    }
    .share-user .content {
          flex: 1;
        font-size: 12px;
         margin: auto auto;
          padding: 0 10px;
        text-align: left;
    }
     .share-user .content .sign{
          color:#b0b9c0;
     }
     .share-user .content .sign span{
         font-sise:9px;
         float:right;
     }
       .share-user .content .sc{

           line-height:36px;
           font-size:1.1em;
           height:36px;
           overflow:hidden;
           
       }
    .share-user:last-child {
        border-bottom: none !important;
    }

</style>